import { useQuery } from '@tanstack/react-query'
import { clientApi } from '@/lib/api-client'

export function useClientAccounts(clientId: string | null | undefined) {
  return useQuery({
    queryKey: ['client', 'accounts', clientId],
    queryFn: () => clientApi.getAccounts(clientId!),
    enabled: Boolean(clientId),
  })
}
